import React from 'react';
import './TemplatePagination.css';

/**
 * Template Pagination Component
 * Handles pagination controls for template lists
 */
const TemplatePagination = ({ pagination, onPageChange }) => {
    const { page, totalPages, hasNextPage, hasPrevPage, filtered, total } = pagination;

    if (totalPages <= 1) {
        return null; // Don't show pagination if only one page
    }

    return (
        <div className="template-pagination">
            <button
                onClick={() => onPageChange(page - 1)}
                disabled={!hasPrevPage}
                className="pagination-btn"
            >
                ← Previous
            </button>

            <span className="pagination-info">
                Page {page} of {totalPages}
                {filtered !== total && (
                    <span className="pagination-filter-info">
                        ({filtered} filtered)
                    </span>
                )}
            </span>

            <button
                onClick={() => onPageChange(page + 1)}
                disabled={!hasNextPage}
                className="pagination-btn"
            >
                Next →
            </button>
        </div>
    );
};

export default TemplatePagination;
